import { Layout } from "../../layouts/v1";

export default function RootPage() {
    return (
        <Layout>
            <div>
                <h1>홈</h1>
            </div>
        </Layout>
    );
}